// extracted by mini-css-extract-plugin
export default {"sentContainer":"uKHoE26q6v8wRdyjEVDH","tooltipBodyContainer":"bWHhWy5YnNMMgh1SGqYv"};